import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { map } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CacheService } from '../../_service/cache.service';
import * as routeConfigData from '../../../assets/config/routeconfig.json';
import { RouterConfig } from '../../_interface/router-config.interface';
import { filter } from 'rxjs/operators';
import { each } from 'highcharts';
import { ComponentInteractionService } from '../../_service/component-interaction.service';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { ThemeService } from '../../_service/theme.service';
import { ServiceAdapterService } from '../../_service/service-adapter.service';
import { HttpResponse } from '../../_interface/http-response.interface';
import { FilterComponent } from '../../shared/filter/filter.component';
import { CommonService } from '../../_service/common.service';
import { isBuffer } from 'util';
import { MsalService } from '@azure/msal-angular';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FormGroup, FormControl, FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeyValue, SlicePipe } from '@angular/common';
import { NavdataService } from '../../_service/navdata.service';
import { PlantViewComponent } from '../../modules/plant-view/plant-view/plant-view.component';
declare var $: any;

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css'],
})
export class NavComponent implements OnInit, OnDestroy {
  @Input() startdateRange: Date;
  @Input() enddateRange: Date;
  loadingFlag: boolean = false;
  notiCount: any = {};
  activeItem: string;
  trimUser: string;
  uiTabs: any = [];
  uiSubTabs: any = [];
  showfirstblock: boolean = false;
  showsecondblock: boolean = false;
  resetDate = true;
  selectedView;
  filterSelection;
  placement = 'top';
  setSelectedIndex = false;
  getidvalue: number = 0;
  getsubidvalue: number = 0;
  subentire: any = [];
  entevalue: any = [];
  allDatavalues: any = [];
  infoNote: any = [];
  setActiveItem(page: string) {
    this.activeItem = page;
  }
  onSubmitFormJson = {
    intervalSelection: '',
    fromDate: '',
    toDate: '',
  };
  pageTitle: string = 'ENTERPRISE DASHBOARD';
  graphOrMapView = ['AS GRAPH VIEW', 'AS MAP VIEW'];
  lastUpdatedText = 'View Last Plant Updated Details';
  showMapView: boolean = false;
  showReportblock: boolean = false;
  buildingFlag: boolean = false;
  dashboardFlag: boolean = false;
  showtab: any[];
  current: string;
  activeLinkIndex = -1;
  routerData ;
  routerConfigData = sessionStorage.getItem('routerconfig');
  routerDataCondition
  routFlagData;
  links = ['Meter Consumption', 'Energy', 'Virtual Meter'];
  activeLink = this.links[0];
  subscription: Subscription;
  assetSubscription: Subscription;
  dropDownArray: any = [];
  locationArray: any = [];
  facilityArray: any = [];
  location: string = '';
  facility: string = '';
  matChipDisplayArray = [];
  contentDataArray = [];
  removable = true;
  rawDataFlag = false;
  selectOption = ['1', '2', '3', '4'];
  routeenter = [];
  remove(value, key, index) {
    if (key == 'assets') {
      let values = _.cloneDeep(this.filter.modelJson[key][index]['value']);
      values = values.filter((data) => data != value);
      this.filter.modelJson[key][index]['value'] = _.cloneDeep(values);
      this.filter.onChangeAsset(index, 'dynamicfilteremoved', key);
    } else {
      let type = this.contentDataArray[key]['type'];
      let values = _.cloneDeep(this.filter.modelJson[key]['value']);
      values = values.filter((data) => data != value);
      this.filter.modelJson[key]['value'] = _.cloneDeep(values);
      if (type == 'static') {
        this.filter.onChangeStaticFilter(key, 'fromappliedfilter');
      } else {
        if (this.dataExplorerFlag || this.kpiFlag || this.dashboardFlag)
          this.filter.getAssetData(index, 'dynamicfilteremoved', key);
      }
    }
  }
  mapJsonValue;
  options = {
    title: 'All',
    maxHeight: 200,
    expandHandler: function (element, expanded) {
    },
    checkHandler: function (element, checked) {
    },
    closedArrow: '<i class="fa fa-clock" aria-hidden="true"></i>',
    openedArrow: '<i class="fa fa-clock" aria-hidden="true"></i>',
    multiSelect: false,
    selectChildren: true,
  };
  isFilterOpen = false;
  imgTemplateVar = 'rla.isActive ? obj.image : obj.selectedImage';
  userName = sessionStorage.getItem('userName');
  filterText = 'FILTER';
  @ViewChild(FilterComponent, { static: true }) filter: FilterComponent;
  dataExplorerFlag = false;
  kpiFlag = false;
  assetBreakUpFlag = false;
  rulesPageBuildFlag = false;
  assetViewFlag = false;
  analyticsFlag = false;
  trendsFlag = false;
  dataAvailFlag = false;
  dataQualityFlag = false;
  comparisonFlag = false;
  adminFlag = false;
  toolsFlag = false;
  reportFlag = false;
  alertdaFlag = false;
  alertdqFlag = false;
  comparisonPlantFlag = false;
  dadqFlag = false;
  kpisubFlag = false;
  PlantFlag = false;
  breakupFlag = false;  
  tabFlag = false;
  showKpiblock = false;
  alertFlag = false;
  breakupSubFlag = false;
  newComparisionEnterpriseFlag: boolean = false;
  filterDisableFlag: boolean = false;
  ipmvpFlag = false;
  meterhierachyFlag = false;
  assetViewreportFlag = false;
  assetViewdadqFlag = false;
  assetViewsavingsFlag = false;
  filterDisableArr = [];
  appConfig = {};
  tableConstantHeader = [];
  tableConstantData = [];
  tableconsumptionHeader = [];
  tableconsumptionData = [];
  tableProductionHeader = [];
  tableProductionData = [];
  trendsEnterpriseFlag = false;
  routEnterprise;
  userId = sessionStorage.getItem('userId');
  enableURMFlag = JSON.parse(sessionStorage.getItem('appconfig'))[
    'enableURMFlag'
  ];
  routerService = this.enableURMFlag
    ? 'getRouterConfigFromService'
    : 'getRouterConfig';
  assetOptionsArr = [];
  selectedValue = 'chillerandcoolingtower';
    allowMultiEntitySelection = {};
      action: string = "";
  constructor(
    private themeService: ThemeService,
    private router: Router,
    private cacheService: CacheService,
    private activatedRoute: ActivatedRoute,
    private componentInteractionService: ComponentInteractionService,
    private serviceAdapterService: ServiceAdapterService,
    private commonService: CommonService,
    private msalService: MsalService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private navdataService:NavdataService
  ) {
    let reqJson = { "userID": sessionStorage.getItem('userId') };
    this.filterDisableFlag = false;
      this.allowMultiEntitySelection = {};
     if (this.routerConfigData === null) {
      this.loadingFlag = true;
      this.serviceAdapterService.backendServiceCall(this.routerService, reqJson).subscribe((data) => {
         this.loadingFlag = false;
        this.routerData = data;
        if (this.routerData && this.routerData.length > 0) {
  const currentUrl = this.router.url;
  setTimeout(()=>{
    this.handleRouterEvent({ url: currentUrl } as NavigationEnd); // manual call
  },200)
}
 
        sessionStorage.setItem('routerconfig', JSON.stringify(this.routerData))
      });
    } else {
      this.routerData = JSON.parse(this.routerConfigData);
    }
    
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event:NavigationEnd) => {
         this.handleRouterEvent(event);
      });

  }

  ngOnInit(): void {
     this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event:NavigationEnd) => {
         this.handleRouterEvent(event);
      });
    this.componentInteractionService.setAssetType(this.selectedValue);
    this.filterSelection = _.filter(
      this.commonService.filterArr,
      (eachObj) => eachObj.flag == true
    )[0]['name'];
    this.onSubmitFormJson.intervalSelection = this.filterSelection;
    this.selectedView = this.graphOrMapView[0];
    this.subscription =
      this.componentInteractionService.getBuildingDropdown.subscribe((data) => {
        this.locationArray = [];
        this.facilityArray = [];

        this.dropDownArray = data;
        _.map(this.dropDownArray, (eachobj, index) => {
          let that = this;
          _.forEach(eachobj, function (value, key) {
            if (index == 0) that.facilityArray = value;
            that.locationArray.push(key);
          });
        });

        this.location = this.locationArray[0];
        this.facility = this.facilityArray[0];
                this.componentInteractionService.passBuildingDropdownChangeData(
          this.facility
        ); /////Pass default value
      });
    this.componentInteractionService.getFilterJson.subscribe((data) => {
      if (data['modelJson']) {
        data['modelJson']['climaticFilter'] = [];

        this.matChipDisplayArray = _.cloneDeep(data.modelJson);
        this.infoNote =
          this.matChipDisplayArray['buildings'][0].value.toString();

        this.contentDataArray = data.modelJsonDropdown;
      }
    });

    this.trimUser = this.userName;
    if (this.userName.length > 10)
      this.userName = this.userName.substring(0, 10);
    this.getDropdownassestview();
  }
handleRouterEvent(event:NavigationEnd){
  this.filterDisableArr = [];
        this.getsubidvalue = 0;
        this.getidvalue = 0;
        this.uiTabs = [];
        this.uiSubTabs = [];
         this.action = "";
        this.dashboardFlag =
          event['url'].indexOf('dashboard') != -1 ? true : false;
        this.PlantFlag = event['url'].indexOf('plantview') != -1 ? true : false;
        this.breakupFlag = event['url'].indexOf('breakup') != -1 ? true : false;
        this.trendsFlag = event['url'].indexOf('trends') != -1 ? true : false;
        this.trendsEnterpriseFlag = event['url'].indexOf('trends/enterprise/timeofday') != -1 ? true : false;
         
        this.comparisonFlag =
          event['url'].indexOf('comparison/enterprise') != -1 ? true : false;
        this.comparisonPlantFlag =
         event['url'].indexOf('comparison/plant') != -1 ? true : false;
        this.kpiFlag =
          event['url'].indexOf('kpi/enterprise') != -1 ? true : false;
        this.reportFlag = event['url'].indexOf('reports') != -1 ? true : false;
        this.alertFlag = event['url'].indexOf('alerts') != -1 ? true : false;
        this.alertdaFlag =
          event['url'].indexOf('alerts/da') != -1 ? true : false;
          this.alertdqFlag =
          event['url'].indexOf('alerts/dq') != -1 ? true : false;
        this.dadqFlag = event['url'].indexOf('dadq') != -1 ? true : false;
        this.dataAvailFlag =
          event['url'].indexOf('dadq/dataavailability') != -1 ? true : false;
        this.dataQualityFlag =
          event['url'].indexOf('dadq/dataquality') != -1 ? true : false;
        this.adminFlag = event['url'].indexOf('admin') != -1 ? true : false;
        this.kpisubFlag =
          event['url'].indexOf('kpi/plant') != -1 ? true : false;
        this.assetViewFlag =
          event['url'].indexOf('assetview') != -1 ? true : false;
        this.assetViewreportFlag =
          event['url'].indexOf('assetview/asstcompar') != -1 ? true : false;
        this.assetViewdadqFlag =
          event['url'].indexOf('assetview/dadq') != -1 ? true : false;
        this.assetViewsavingsFlag =
          event['url'].indexOf('assetview/savings') != -1 ? true : false;
        this.ipmvpFlag = event['url'].indexOf('ipmvp') != -1 ? true : false;
        this.meterhierachyFlag =
          event['url'].indexOf('meterhierarchy') != -1 ? true : false;
// ADD THIS CHECK(before using this.routerData)
if (!this.routerData || this.routerData.length === 0) {
  setTimeout(() => this.router.navigateByUrl(event.url)); // re-trigger when routerData is loaded
  return; // stop further execution for now
}
        var entiresub = this.routerData.find(
          (eachobj) => eachobj['link'].indexOf(event['url'].split('/')[1]) != -1
        );
        
        this.newComparisionEnterpriseFlag =
          event['url'].indexOf('comparison/enterprise/newenterprise') != -1
            ? true
            : false;
        this.pageTitle = entiresub['title'];
        
        this.showfirstblock = entiresub['submenu'] != undefined ? true : false;
             let reqJson = { "userID": sessionStorage.getItem('userId') };
             
        if (this.showfirstblock) {
          let url =
            event['url'].split('/')[1] + '/' + event['url'].split('/')[2];
          let subtabObj = _.find(
            entiresub['submenu'],
            (subsubtab) => url === subsubtab['link']
          );
          if (subtabObj && Object.keys(subtabObj).length > 0)
            this.subentire = subtabObj['subtab'];
          this.showsecondblock =
            this.subentire != '' &&
              this.subentire !== null &&
              this.subentire !== undefined
              ? true
              : false;

          this.uiTabs = entiresub['submenu'];
          _.map(this.uiTabs, (subtabid) => {
            let url =
              event['url'].split('/')[1] + '/' + event['url'].split('/')[2];
            if (url === subtabid['link']) {
              this.getidvalue = subtabid['id'];
            }
          });
       if (this.uiTabs.length > 0 && this.getidvalue !== -1) {
          if (this.uiTabs[this.getidvalue]['filterDisableArr']) {
            this.filterDisableArr = this.uiTabs[this.getidvalue]['filterDisableArr'];
            this.filterDisableFlag = this.uiTabs[this.getidvalue]['filterDisableFlag'];
            this.allowMultiEntitySelection = this.uiTabs[this.getidvalue]['allowMultiEntitySelection'];
            this.action = this.uiTabs[this.getidvalue]['action'];
          }
        }

          this.uiSubTabs = this.subentire;
          _.map(this.uiSubTabs, (subsubtabid) => {
            if (event['url'].substring(1) === subsubtabid['link']) {
              this.getsubidvalue = subsubtabid['id'];
            }
          });
        if ((this.uiSubTabs && this.uiSubTabs.length > 0) && this.getsubidvalue !== -1) {
          this.filterDisableArr = this.uiSubTabs[this.getsubidvalue]['filterDisableArr'];
          this.filterDisableFlag = this.uiSubTabs[this.getsubidvalue]['filterDisableFlag'];
          this.allowMultiEntitySelection = this.uiSubTabs[this.getsubidvalue]['allowMultiEntitySelection'];
          this.action = this.uiSubTabs[this.getsubidvalue]['action'];
          }
        
      } else {
        this.filterDisableArr = entiresub['filterDisableArr'];
        this.filterDisableFlag = entiresub['filterDisableFlag'];
        this.allowMultiEntitySelection = entiresub['allowMultiEntitySelection'];
        this.action = entiresub['action']
      }
        if (isNaN(this.getidvalue) || this.getidvalue < 0) this.getidvalue;
        if (isNaN(this.getsubidvalue) || this.getsubidvalue < 0)
          this.getsubidvalue;
        this.filterDisableFlag =
          this.reportFlag ||
            this.adminFlag ||
            this.meterhierachyFlag ||
            this.comparisonFlag ||
            this.comparisonPlantFlag ||
            this.dataAvailFlag ||
            this.dataQualityFlag ||
            this.alertdaFlag ||
            this.alertdqFlag ||
            this.assetViewreportFlag ||
            this.assetViewsavingsFlag ||
            this.newComparisionEnterpriseFlag
            ? true
            : false;
    }


  // Order by descending property key
  getDropdownassestview() {
    this.serviceAdapterService.backendServiceCall<HttpResponse<'getDropdownBuildingwise', ''>>(
        'getDropdownBuildingwise','').pipe(
        map((resData) => {
          return resData['data']['assestDropdown'];
        })
      )
      .subscribe((data) => {
        this.assetOptionsArr = data['SONIPAT'];
      });
  }
  keyDescOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return a.key > b.key ? -1 : b.key > a.key ? 1 : 0;
  };

  onLabelChange(label, type, j?: any) {
    if (type === 'assets') {
      if (
        this.contentDataArray[type] &&
        this.contentDataArray[type].length > 0
      ) {
        if (this.contentDataArray[type][j]) {
          let data = _.find(
            this.contentDataArray[type][j]['value'],
            (data) => data['value'] === label
          );
          if (data !== undefined) {
            return data['key'];
          }
        }
      }
    } else {
      let data = _.find(
        this.contentDataArray[type]['value'],
        (data) => data['value'] === label
      );
      this.allDatavalues = this.contentDataArray['geoFilter'];
      if (data != undefined) {
        let labelChip = data['key'] === undefined ? data['value'] : data['key'];
        return labelChip;
      }
    }
  }

  onfilterClick(json) {
    this.filterSelection = json['name'];
    this.setSelectedIndex = false;
    this.resetDate = true;
    this.onSubmitFormJson.intervalSelection = this.filterSelection;
    this.onSubmitFormJson.fromDate = '';
    this.onSubmitFormJson.toDate = '';
  }

  changeGraphOrMapView(event) {
    this.selectedView = event.target.value;
    if (
      event.target.value.substring(3, event.target.value.length) ==
      this.graphOrMapView[0]
    ) {
      this.showMapView = false;
    }
  }

  getSelectedDateRange(event) {
    this.setSelectedIndex = true;
    this.resetDate = false;
    this.onSubmitFormJson.intervalSelection = 'custom';
    this.onSubmitFormJson.fromDate = event[0];
    this.onSubmitFormJson.toDate = event[1];
  }
  onLocationChange(data) {
    //needs to be check
    _.map(this.dropDownArray, (eachobj, index) => {
      let that = this;
      _.forEach(eachobj, function (value, key) {
        if (key === data) that.facilityArray = value;
      });
    });
    this.facility = this.facilityArray[0];
    this.componentInteractionService.passBuildingDropdownChangeData(
      this.facility
    );
  }

  uiSwitchTab(tabname, subtabArr) {
    let getSubTabValue = subtabArr.find(
      (subtabObj) => subtabObj['name'] === tabname
    );
    this.router.navigateByUrl(getSubTabValue['link']);
  }

  uiSwitchSubMenu(tabname1, subtabArr1) {
    let getSubsubTab = subtabArr1.find(
      (subtabObj1) => subtabObj1['name'] === tabname1
    );
    this.router.navigateByUrl(getSubsubTab['link']);
    }

  onFacilityChange(data) {
    this.componentInteractionService.passBuildingDropdownChangeData(
      this.facility
    );
  }

  disabledLink: boolean = false;
  onNavigationClick(obj: RouterConfig) {
    this.subentire = [];
    if (obj['submenu']) {
      this.uiTabs = obj['submenu'];
      if (obj['submenu']['subtab']) {
        obj['submenu'].find((obje) => {
          if (obje['subtab']) {
            this.uiSubTabs = obje['subtab'];
          }
        });
      }
    } else {
      this.uiTabs = [];
      this.uiSubTabs = [];
    }
    this.router.navigateByUrl(obj['link']);
    this.isFilterOpen = false;
  }
  logout() {
    this.modalService.dismissAll();
    this.cacheService.clearCache();
    sessionStorage.removeItem('currentUser');
    sessionStorage.removeItem('routerconfig')
    sessionStorage.removeItem("logged");
    this.router.navigateByUrl('/login');
    this.onsessionStorageRemoveMethod();
  }
 
  sessionStorageArr = ['serviceconfig', 'appconfig', 'selectedValue'];
  onsessionStorageRemoveMethod() {
    let keyArr = Object.keys(sessionStorage);
    keyArr.forEach(key => {
      if (this.sessionStorageArr.indexOf(key) === -1)
        sessionStorage.removeItem(key);
    });
  }

  onNavClick() {
    if (this.buildingFlag) {
      this.componentInteractionService.passBuildingDropdownChangeData(
        this.facility
      );
    }
  }

  //////////////////////Site level Data///////////////
  getSiteLevelData() {
    let payLoad = {};
    if (sessionStorage.hasOwnProperty('accessibleBuiding'))
      payLoad = sessionStorage['accessibleBuiding'];
    let serviceId = 'siteList';
    this.serviceAdapterService
      .backendServiceCall<HttpResponse<typeof serviceId, ''>>(
        'siteList',
        payLoad
      )
      .subscribe((data) => {
        this.mapJsonValue = data;
        this.componentInteractionService.setSiteData(data);
      });
  }

  onClickFilter() {
    this.isFilterOpen = !this.isFilterOpen;
    this.componentInteractionService.setIsFilterOpen(this.isFilterOpen);
  }

  logoutConfirm(content) {
    var appConfig = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
    let azureAuthFlag = appConfig['azureAuthFlag'];
    if (azureAuthFlag) {
      this.cacheService.clearCache();
      sessionStorage.clear();
      this.msalService.logout();
    } else {
      this.modalService.open(content, { centered: true, size: 'md' });
    }
  }

  onClickLogout() {
    var appConfig = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
    let azureAuthFlag = appConfig['azureAuthFlag'];
    if (azureAuthFlag) {
      this.cacheService.clearCache();
      this.msalService.logout();
      this.onsessionStorageRemoveMethod();
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("userName");
      sessionStorage.removeItem("routerconfig")
    } else {
      this.router.navigateByUrl("login");
      this.onsessionStorageRemoveMethod();
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("userName");
     sessionStorage.removeItem("routerconfig")
    }
  }
  onClickAlert() {
    this.router.navigateByUrl('alerts');
  }
  dateRangeChange(dateRangeStart, dateRangeEnd) {
    this.startdateRange = dateRangeStart.value;
    this.enddateRange = dateRangeStart.value;
  }
 
  receiveMessage($event) {
    this.notiCount = $event;
  }
  updatedIcon(content1) {
    this.modalService.open(content1, { centered: true, size: 'xl' });
    this.matChipDisplayArray = {
      ...this.matChipDisplayArray,
      ...{
        serviceId: 'getDashboardplants',
        userId: 'admin',
        locale: 'en-US',
        requestType: 'lastupdated',
        level: 'buildingLevel',
        convertcost: false,
        status: 'Active',
        timeFilter: {
          fromDate: '',
          toDate: '',
          aggregration: '',
          intervalSelection: 'TYD',
        },
      },
    };

    this.serviceAdapterService
      .backendServiceCall<HttpResponse<'getLastUpdate', ''>>(
        'getLastUpdate',
        this.matChipDisplayArray
      )
      .pipe(
        map((resData) => {
          return resData['data'];
        })
      )
      .subscribe((data) => {
        this.tableconsumptionHeader = data['consumption']['header'];
        this.tableconsumptionData = data['consumption']['data'];
        this.tableProductionHeader = data['production']['header'];
        this.tableProductionData = data['production']['data'];
      });
  }

  onSelectChange(event) {
    this.selectedValue = event;
    this.componentInteractionService.setAssetType(this.selectedValue);
  }

  isOverflown(element: HTMLElement) {
    return element.scrollWidth > element.clientWidth;
  }

  scroll(element: HTMLElement, direction: number) {
    element.scrollLeft += 100 * direction;
  }

  canScrollStart(element: HTMLElement) {
    return element.scrollLeft > 0;
  }

  canScrollEnd(element: HTMLElement) {
    return element.scrollLeft + element.clientWidth != element.scrollWidth;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
